import Vue from 'vue';
import store from '@/store';
const app = new Vue();

export default [
	{  // 自定义字段
		path: 'field/:type',
		name: 'm_custom_field',
		props: route => route.params,
		component: () => import('@/pages/custom/field_list'),
		beforeEnter: (to, from, next) => {
			if (!to.params.type || !app.auth(`m_custom_${to.params.type}`)) {
				let first = store.getters.customFieldMenu[0];
				if (first) {
					next(`/custom/field/${first.menu_unique_key.substring(first.menu_unique_key.lastIndexOf('_') + 1)}`);
				} else {
					next('/');
				}
			} else {
				next();
			}
		}
	}, {  // 自定义编号规则
		path: 'numberRule',
		name: 'm_custom_seqnumber',
		props: route => route.params,
		component: () => import('@/pages/custom/number_rule')
	}
];